import React from 'react';

import ContentContainer from 'common/containers/ContentContainer';
import ReferralTermsHelmet from 'common/helmets/ReferralTermsHelmet';
import Link from 'common/Link';

import 'css/components/_Policy.scss';

const ReferralTerms = () => (
  <ContentContainer innerClassName="referralTerms card">
    <ReferralTermsHelmet />
    <h1>Canny Customer Referral Agreement</h1>
    <h2>1. Overview</h2>
    <p>
      This Referral Program allows registered Canny account holders to earn referral rewards by
      referring new customers to Canny's paid services. Participants in the program ("Referrers")
      can share a unique referral link. When a new customer signs up using this link and meets the
      eligibility criteria, both the Referrer and the referred customer will receive benefits as
      outlined below.
    </p>
    <h2>2. Eligibility</h2>
    <ul>
      <li>
        <p>
          Participants must have an active Canny account and agree to these terms to create a
          referral link via their Canny admin dashboard.
        </p>
      </li>
      <li>
        <p>
          Both the Referrer and their business, if applicable, must be located in countries where
          Canny is legally authorized to send payouts (e.g. non-sanctioned countries).
        </p>
      </li>
    </ul>
    <h2>3. Referral Rewards and Conditions</h2>
    <ul>
      <li>
        <p>
          Canny offers a 20% discount for the first three months to the referred customer’s account
          upon successful signup.
        </p>
      </li>
      <li>
        <p>
          Referrers will receive 20% of the payments made by the referred customer for the first
          three months, up to a maximum of $1,000 per successfully referred customer.
        </p>
      </li>
      <li>
        <p>
          Referrals are valid only if the referred customer signs up within 7 days of clicking the
          referral link and subscribes to a paid plan.
        </p>
      </li>
    </ul>
    <h2>4. Restrictions</h2>
    <ul>
      <li>
        <p>
          Rewards apply only to new customers. Existing free account holders upgrading to a paid
          plan are not eligible.
        </p>
      </li>
      <li>
        <p>
          Referrers are prohibited from using their own referral link (self-referral), creating
          multiple accounts (multi-accounting), or cycling between accounts.
        </p>
      </li>
      <li>
        <p>
          Referral links must not be broadcasted on public platforms such as coupon sites or
          discount databases.
        </p>
      </li>
      <li>
        <p>
          Referrers cannot bid on Canny-related keywords in paid advertising campaigns or create
          content solely to promote their referral discount.
        </p>
      </li>
    </ul>
    <h2>5. Marketing Use</h2>
    <ul>
      <li>
        <p>
          Referrers may use the Canny logo for promotional purposes but must obtain a high- quality
          version directly from Canny’s website.
        </p>
      </li>
      <li>
        <p>
          Referrers are not allowed to run ad campaigns that directly compete with Canny’s own
          campaigns or launch SEO campaigns that significantly compete with Canny’s branded organic
          search results.
        </p>
      </li>
    </ul>
    <h2>6. Tax Responsibilities</h2>
    <ul>
      <li>
        <p>Referrers are responsible for all applicable taxes on their referral rewards.</p>
      </li>
      <li>
        <p>
          Canny may request completion of tax forms such as W-9 or W-8BEN from Referrers to process
          referral payouts.
        </p>
      </li>
    </ul>
    <h2>7. Termination and Changes</h2>
    <ul>
      <li>
        <p>
          Canny reserves the right to terminate the referral program or a participant’s account,
          alter these terms, or discontinue the program at any time without notice.
        </p>
      </li>
    </ul>
    <h2>8. Liability</h2>
    <ul>
      <li>
        <p>
          Canny is not liable for any errors, accidents, or issues arising from participation in the
          referral program.
        </p>
      </li>
    </ul>
    <h2>9. Data Privacy</h2>
    <ul>
      <li>
        <p>
          Participation requires collection and use of personal information, governed by
          Canny’s&nbsp;
          <Link to="/privacy">privacy policy</Link>.
        </p>
      </li>
    </ul>
    <h2>10. Dispute Resolution</h2>
    <ul>
      <li>
        <p>
          Canny holds the final decision authority in disputes related to the referral program.
          While committed to fair conduct, Canny reserves the right to refuse payout in cases of
          suspected fraudulent activity.
        </p>
      </li>
    </ul>
    <h2>11. Communication</h2>
    <ul>
      <li>
        <p>
          For assistance or inquiries about the referral program, participants should contact Canny
          through live chat on the website or via email at{' '}
          <a href="mailto:support@canny.io">support@canny.io</a>.
        </p>
      </li>
    </ul>
    <p>
      By participating in the Canny Customer Referral Program, you acknowledge and agree to the
      terms set forth in this agreement.
    </p>
  </ContentContainer>
);

export default ReferralTerms;
